<template>
  <ImportExport
    :title="$t('keywords.from_to')"
    type="fromto"
    :headers="headers"
    v-on="$listeners"
    :params="{ collection }"
    :desactive-export="desactiveExport"
  >
    <template #item.from="{ item }">
      <v-text-field v-model="item.from" style="margin-bottom: -2.3vh" outlined dense :rules="requiredRules(item.from)" />
    </template>

    <template #item.to="{ item }">
      <v-text-field v-model="item.to" style="margin-bottom: -2.3vh" outlined dense/>
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import { requiredRules } from '../../utils/rules'

export default {

  props: {
    collection: String
  },

  components: { ImportExport },

  data: () => ({
    requiredRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('fromto.from'),
          value: 'from'
        },
        {
          text: this.$t('fromto.to'),
          value: 'to'
        }
      ]
    },
    desactiveExport () {
      return !this.collection ? this.$t('fromto.need_collection') : ''
    }
  }

}
</script>
